import AutoAssignPage from '@/components/feature/AutoAssignPage/AutoAssignPage'
import { Container, Title } from './styles'

const AutoAssign = () => {
  return (
    <Container>
      <Title>การจัดการ Auto assign งานเคลม</Title>
      <AutoAssignPage />
    </Container>
  )
}

export default AutoAssign
